module.exports = __webpack_public_path__ + "media/images/weather/20_night_g-b6f8fc649cd0d3c6b0e9878478f5cc3f.png";